import { render, staticRenderFns } from "./MenuMove.vue?vue&type=template&id=7bcecb47&scoped=true"
import script from "./MenuMove.vue?vue&type=script&lang=js"
export * from "./MenuMove.vue?vue&type=script&lang=js"
import style0 from "./MenuMove.vue?vue&type=style&index=0&id=7bcecb47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcecb47",
  null
  
)

export default component.exports